import { DragEvent } from 'react';
import { DragIcon } from '../../../../common/ui/icons';
import { IFileSystemItem } from '../../wiki-interfaces';

interface IWikiMenuDragButtonProps {
    item: IFileSystemItem;
    visible: boolean;
}

const WikiMenuDragButton = ({ item, visible }: IWikiMenuDragButtonProps) => {

    /**
     * https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setData
     */
    const sourceOnDragStart = (evt: DragEvent<HTMLButtonElement>) => {
        evt.stopPropagation();

        // Clear the actions data cache (for all formats/types)
        evt.dataTransfer.clearData();

        evt.dataTransfer.setData('text/plain', item.path.toString());

        // https://stackoverflow.com/questions/19639969/html5-dragend-event-firing-immediately
        ((_currentTarget) => {
            window.setTimeout(() => {
                document.body.classList.add('wiki-menu-dragging');
            }, 0)
        })(evt.currentTarget);
    };

    const sourceOnDragEnd = (evt: DragEvent<HTMLButtonElement>) => {

        evt.stopPropagation();

        document.body.classList.remove('wiki-menu-dragging');
    };

    const sourceOnDrag = (evt: DragEvent<HTMLButtonElement>) => {
        evt.stopPropagation();
    };


    return (
        <button
            type="button"
            draggable={ true }
            onDragStart={ sourceOnDragStart }
            onDragEnd={ sourceOnDragEnd }
            onDrag={ sourceOnDrag }
            className={ `wiki-menu__drag-btn cursor-move ml-auto ${ visible ? '' : 'invisible' }` }>
            <DragIcon
                color={ '#88a3d0' }
            />
        </button>
    )
};

export default WikiMenuDragButton;